import { Directive, HostBinding, HostListener, Input } from '@angular/core';
import {
  ClipboardCopyService,
  PUBLIC_COPY_OPTIONS,
} from '../services/clipboard-copy.service';

export type CopyContext = 'admin' | 'public';

/**
 * The one copy-to-clipboard entry point for templates (#11629).
 *
 * Put it on the copy icon and bind the value; the directive forwards both the
 * value and the click event to {@link ClipboardCopyService}, which owns the
 * clipboard write and the inline check + "Copied" tooltip. It exists to delete
 * the ~20 per-screen wrapper methods that did nothing but that forwarding, so a
 * new copy icon gets the standard feedback without any component code.
 *
 * `copyContext="public"` switches to the storefront flavour (store theme
 * colour, storefront translation set, no failure toaster).
 */
@Directive({
  selector: '[appCopyToClipboard]',
})
export class CopyToClipboardDirective {
  /** Numbers are accepted so numeric ids (the stores list) can be bound as they are. */
  @Input('appCopyToClipboard') value: string | number | null | undefined;
  @Input() copyContext: CopyContext = 'admin';

  @HostBinding('class.cursor-pointer') readonly pointer = true;

  constructor(private readonly clipboardCopyService: ClipboardCopyService) {}

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    this.clipboardCopyService.copy(
      this.value == null ? '' : String(this.value),
      event,
      this.copyContext === 'public' ? PUBLIC_COPY_OPTIONS : undefined,
    );
  }
}
